"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./MegaNav.scss");
var _crossMediumBlue = _interopRequireDefault(require("../../images/cross-medium-blue.svg"));
var _MegaNavSection = _interopRequireDefault(require("./MegaNavSection"));
var _NavBar = require("../NavBar/NavBar");
var _useScreenSize = require("../../utils/hooks/useScreenSize");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const MegaNav = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    mouse,
    noImmediateMouseOver,
    closeDropDown,
    deployDropDown
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  const {
    content,
    isOpen,
    currentOpenMenu,
    parentWrapperRef,
    Link,
    setMegaNavIsActive
  } = props;
  const {
    width
  } = (0, _useScreenSize.useScreenSize)();
  const megaNavWrapperRef = (0, _react.useRef)(null);
  const featuredColumnRef = (0, _react.useRef)(null);
  const [featuredColumnBgLeft, setFeaturedColumnBgLeft] = (0, _react.useState)(0);
  const [featuredColumnBgHeight, setFeaturedColumnBgHeight] = (0, _react.useState)(0);
  const handleClick = (e, menuId) => {
    deployDropDown(e, menuId);
    setMegaNavIsActive(true);
  };
  (0, _react.useImperativeHandle)(ref, () => ({
    handleClick() {
      handleClick();
    }
  }));
  const mouseOver = e => {
    if (!noImmediateMouseOver && currentOpenMenu !== content) {
      deployDropDown(e, content?.contentfulId);
    }
  };
  const mouseOverWithKeys = event => {
    if (mouse === false) {
      // checks that a user hits the enter key to open the modal
      if (event.keyCode === 13) {
        !isOpen && mouseOver(event);
      } else if (event.keyCode === 27) {
        closeDropDown(content?.contentfulId);
      }
    }
  };
  (0, _react.useEffect)(() => {
    if (featuredColumnRef?.current?.offsetLeft) {
      setFeaturedColumnBgLeft(featuredColumnRef?.current?.offsetLeft);
    }
  }, [width]);
  (0, _react.useEffect)(() => {
    if (megaNavWrapperRef?.current?.offsetHeight) {
      setFeaturedColumnBgHeight(megaNavWrapperRef?.current?.offsetHeight);
    }
  }, [megaNavWrapperRef?.current?.offsetHeight, width]);
  const megaNavSectionContent = {
    columns: content?.links,
    featuredSection: content?.featuredSection,
    navCategoryPromo: content?.navCategoryPromo,
    displayChevrons: content?.displayChevrons || false,
    // default to not show chevrons
    disableLinkDescriptions: content?.disableLinkDescriptions || false // default to show link descriptions
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    // className={`ter-mega-nav ${isOpen ? "ter-mega-nav--is-open" : ""}`}
    "aria-haspopup": "menu",
    "aria-expanded": isOpen,
    "aria-label": `${content?.text} menu`
  }, /*#__PURE__*/_react.default.createElement("p", {
    "data-depth": 1,
    onKeyDown: e => mouseOverWithKeys(e),
    onClick: e => handleClick(e, content?.contentfulId),
    tabIndex: "0",
    className: `ter-mega-menu__nav-text ${isOpen ? "ter-mega-menu__nav-text--is-open" : ""}
          `
  }, content?.text, /*#__PURE__*/_react.default.createElement("img", {
    src: _crossMediumBlue.default,
    alt: "cross icon",
    tabIndex: "-1",
    "aria-label": isOpen ? "Opened" : "Closed",
    className: `ter-nav-icon-cross ${isOpen ? "ter-nav-icon-cross--is-open" : ""}
            `
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-mega-nav-outer ${isOpen ? `ter-mega-nav-outer--is-open ` : ""}`,
    style: parentWrapperRef?.current && {
      top: parentWrapperRef?.current?.offsetTop + parentWrapperRef?.current?.clientHeight
    }
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mega-nav__wrapper ter-mega-nav ${isOpen ? `ter-mega-nav--is-open ` : ""}`,
    ref: megaNavWrapperRef
  }, /*#__PURE__*/_react.default.createElement(_MegaNavSection.default, {
    content: megaNavSectionContent,
    featuredColumnRef: featuredColumnRef,
    Link: Link
  })), (megaNavSectionContent?.navCategoryPromo || megaNavSectionContent?.featuredSection) && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-mega-nav__featured-section-background",
    style: {
      left: featuredColumnBgLeft,
      height: featuredColumnBgHeight
    }
  })));
});
var _default = MegaNav;
exports.default = _default;